{
  "title": "Узлы",
  "add": "Добавить узел",
  "filter": "фильтр",
  "filterAria": "Фильтр по имени или адресу",
  "filterEmpty": "Под фильтр ничего не попало",
  "filterEmptyHint": "Смягчите условие: снимите фильтр по состоянию или очистите строку поиска.",
  "emptyTitle": "На этой площадке пока нет узлов",
  "emptyHint": "Узел — это устройство, которое платформа проверяет и к которому подключается: сервер, камера, коммутатор, рабочая станция. Добавьте первый и задайте ему монитор доступности.",
  "noSitesHint": "Узлы принадлежат площадке, а мониторы выполняет её агент. Создайте площадку в разделе «Площадки», затем поставьте на неё агента.",
  "loadFailed": "Не удалось загрузить узлы",
  "loadFailedHint": "{{reason}} Проверьте связь с сервером.",
  "deleteAria": "Удалить узел {{name}}",
  "deleteTitle": "Удалить узел",
  "deleteConfirm": "Удалить узел «{{name}}»? Его мониторы будут отключены.",
  "noMonitor": "монитор не задан",
  "pickNode": "Выберите узел, чтобы увидеть его мониторы.",
  "shownOf": "показано {{shown}} из {{total}}",
  "liveOn": "статусы обновляются в реальном времени",
  "liveOff": "нет связи",
  "statusFilter": "{{status}}: {{count}}",
  "monitorsCount_one": "{{count}} монитор",
  "monitorsCount_few": "{{count}} монитора",
  "monitorsCount_many": "{{count}} мониторов",
  "monitorsCount_other": "{{count}} монитора",
  "linksCount_one": "{{count}} связь",
  "linksCount_few": "{{count}} связи",
  "linksCount_many": "{{count}} связей",
  "linksCount_other": "{{count}} связи",
  "column": {
    "rtt": "RTT, мс"
  },
  "summary": {
    "warn": "{{monitors}} · часть не проходит",
    "down": "{{monitors}} · не отвечает",
    "unknown": "{{monitors}} · проверок ещё не было"
  },
  "status": {
    "up": "Доступен",
    "down": "Недоступен",
    "warn": "Часть проверок не проходит",
    "unknown": "Состояние неизвестно"
  },
  "live": {
    "on": "Статусы приходят по WebSocket",
    "off": "Нет подписки на статусы: показаны последние известные значения",
    "active": "Подписка активна",
    "lost": "Подписка потеряна",
    "offline": "офлайн"
  },
  "kind": {
    "pc": "ПК",
    "server": "сервер",
    "cloud": "облачный сервер",
    "camera": "камера",
    "nvr": "видеорегистратор",
    "switch": "коммутатор",
    "router": "роутер",
    "printer": "принтер",
    "ap": "точка доступа",
    "nas": "хранилище",
    "ups": "ИБП",
    "phone": "телефон",
    "label": "подпись",
    "other": "прочее"
  },
  "field": {
    "name": "Имя",
    "address": "Адрес",
    "kind": "Тип",
    "group": "Группа",
    "noGroup": "без группы",
    "layer": "Слой",
    "notes": "Заметки"
  },
  "form": {
    "name": "Имя узла",
    "addressHint": "пусто — мониторам придётся задавать цель вручную",
    "addressPlaceholder": "IP или имя узла",
    "layerAria": "Слой узла",
    "layerHint": "Слой карты, на котором узел нарисован",
    "layerFromFrame": "Узел лежит в рамке и переезжает на слой вместе с ней",
    "layerHidden": "{{name}} · скрыт",
    "movesWithFrame": "узел переезжает вместе со своей рамкой",
    "layerIsHidden": "этот слой сейчас скрыт — узла не будет видно",
    "notesPlaceholder": "что важно знать про этот узел"
  },
  "linkPoints": {
    "title": "Точки связей",
    "hint": "Сколько мест на каждой стороне, куда можно привести связь. Точки распределяются по стороне равномерно.",
    "sideAria": "Точки связей: {{side}}",
    "warning": "Точек стало меньше, чем нужно: {{links}} останутся без места крепления и будут удалены.",
    "question": "{{links}} потеряют точку крепления и будут удалены без возможности вернуть. Сохранить?"
  },
  "side": {
    "top": "сверху",
    "right": "справа",
    "bottom": "снизу",
    "left": "слева"
  },
  "metadata": {
    "title": "Метаданные",
    "key": "поле",
    "value": "значение",
    "keyAria": "Имя поля {{index}}",
    "valueAria": "Значение поля {{index}}",
    "pinAria": "Показывать поле {{index}} на карте",
    "deleteAria": "Удалить поле {{index}}",
    "add": "Добавить поле",
    "pinHint": "флажок — показывать поле на карте, не больше {{limit}}",
    "onMap": "на карте"
  },
  "agentWarn": {
    "offlineTitle": "Агент площадки не на связи",
    "missingTitle": "На площадке нет агента",
    "offlineText": "Проверки выполняет агент площадки, а он сейчас не подключён: мониторы заведены, но никто их не выполняет. Проверьте службу netdeck-agent в разделе «Агенты».",
    "missingText": "Проверки выполняет агент, установленный на площадке. Пока его нет, узлы остаются в состоянии «неизвестно». Добавьте агента в разделе «Агенты» и выполните команду установки на любой машине этой сети."
  },
  "addresses": {
    "title": "Дополнительные IP-адреса",
    "empty": "Дополнительных адресов нет",
    "add": "Добавить адрес",
    "hint": "Одиночный адрес или диапазон: 192.168.0.4 либо 192.168.0.100 - 192.168.0.109",
    "placeholder": "192.168.0.100 - 192.168.0.109",
    "invalid": "Не разобрать: нужен адрес или диапазон через дефис",
    "inherits": "Проверяются так же, как основной монитор узла",
    "total": "Всего {{total}} из {{max}}",
    "tooMany": "На узел не больше {{max}} дополнительных адресов",
    "responding": "отвечают {{responding}} из {{total}}",
    "strip": "Дополнительные адреса: отвечают {{responding}} из {{total}}",
    "rowAria": "Адрес или диапазон, строка {{index}}",
    "deleteAria": "Удалить строку {{index}}",
    "more": "+{{count}}",
    "moreTitle": "Ещё {{count}} дополнительных адресов",
    "state": {
      "up": "отвечает",
      "down": "не отвечает",
      "unknown": "не проверялся"
    }
  },
  "addressesCount_one": "{{count}} адрес",
  "addressesCount_few": "{{count}} адреса",
  "addressesCount_many": "{{count}} адресов",
  "addressesCount_other": "{{count}} адреса"
}
